// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"50ff7b23","126":"8a56b078","282":"d1c70f16","356":"5518dffc","406":"9db12572","437":"429b3c96","486":"dd757607","653":"84a8b267","706":"00486d25","718":"9cb1407c","772":"11afe070","817":"50ff7b23"}[chunkId] + ".chunk.js";
};